module.exports = __webpack_public_path__ + "img/border.baa2c135.png";